import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaInformacionDireccionesAgregarComponent {
  empresaId = undefined
  agregar = false
  estados
  data = {
    calle: null,
    codigo_postal: null,
    colonia: null,
    idEstado: null,
    estado: null,
    localidad: null,
    municipio: null,
    numero_exterior: null,
    numero_interior: null,
    pais: null,
  }

  constructor (FanProyectoCatalogosEstadosService) {
    this.FanProyectoCatalogosEstadosService = FanProyectoCatalogosEstadosService
  }

  $onInit () {
    this.FanProyectoCatalogosEstadosService.get()
    .then(({data}) => (this.estados = data))
  }

  agregarDireccion () {
    this.data.estado = this.estados.find(item => item.id === this.data.idEstado).descripcion
    this.agregar = true
  }
}

module.component('empresaInformacionDireccionesAgregar', {
  controller: EmpresaInformacionDireccionesAgregarComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/direcciones/agregar/component.js